import React from "react";
import { motion } from "framer-motion";
import PageLayout from "@/components/PageLayout";

export default function LegalPage() {
  return (
    <PageLayout>
      <div className="max-w-3xl mx-auto px-6 py-16">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <h1 className="text-4xl sm:text-5xl font-bold mb-2" data-testid="legal-heading">Legal Notice</h1>
          <p className="text-sm text-[var(--qn-foreground-subtle)] mb-12">Juridisk merknad</p>
        </motion.div>

        <div className="prose-legal space-y-10 text-[var(--qn-foreground-muted)] leading-relaxed text-sm">
          <section>
            <h2 className="text-base font-semibold text-[var(--qn-foreground)] mb-3">Company Information</h2>
            <p>This website and the QNNEAL platform are operated by:</p>
            <div className="mt-3 p-4 rounded-lg border border-[var(--qn-border)] bg-[var(--qn-surface)]">
              <p className="font-medium text-[var(--qn-foreground)]">Global InTech AS</p>
              <p>Organisasjonsnummer: NO 935 706 998</p>
              <p>Registered Address: R&oslash;o 95, 5457 H&oslash;ylandsbygd, Norway</p>
              <p>Email: contact@qnneal.dev</p>
              <p>Phone: +47 404 00 755</p>
            </div>
            <p className="mt-3">Global InTech AS is a limited liability company (aksjeselskap) registered in the Norwegian Register of Business Enterprises (Br&oslash;nn&oslash;ysundregistrene).</p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-[var(--qn-foreground)] mb-3">Disclaimer</h2>
            <p>The information provided on this website and through the QNNEAL platform is for general informational purposes only. While we strive to ensure accuracy and reliability, Global InTech AS makes no warranties or representations, express or implied, regarding the completeness, accuracy, or suitability of the information, products, or services contained on this website.</p>
            <p className="mt-3">Use of the QNNEAL platform is subject to our Terms of Service. Any reliance you place on information provided through this website or platform is strictly at your own risk.</p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-[var(--qn-foreground)] mb-3">Intellectual Property</h2>
            <p>All content on this website &mdash; including but not limited to text, graphics, logos, icons, images, software, and the QNNEAL brand &mdash; is the property of Global InTech AS or its licensors and is protected by Norwegian and international copyright, trademark, and intellectual property laws.</p>
            <p className="mt-3">The QNNEAL name, logo, and associated branding are trademarks of Global InTech AS. Unauthorized use, reproduction, or distribution of any materials from this website is strictly prohibited without prior written consent.</p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-[var(--qn-foreground)] mb-3">Limitation of Liability</h2>
            <p>To the maximum extent permitted by Norwegian law, Global InTech AS shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of or inability to use this website or the QNNEAL platform, including but not limited to loss of data, revenue, or business opportunities.</p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-[var(--qn-foreground)] mb-3">Governing Law</h2>
            <p>This legal notice and any disputes arising from the use of this website or the QNNEAL platform shall be governed by and construed in accordance with the laws of the Kingdom of Norway. Any legal proceedings shall be subject to the exclusive jurisdiction of the courts of Norway.</p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-[var(--qn-foreground)] mb-3">Contact</h2>
            <p>For legal inquiries, please contact: <a href="mailto:legal@qnneal.dev" className="text-[var(--qn-primary)] hover:underline">legal@qnneal.dev</a></p>
          </section>
        </div>
      </div>
    </PageLayout>
  );
}
